import { render, staticRenderFns } from "./DistrictSchoolField.vue?vue&type=template&id=42224642&scoped=true&"
import script from "./DistrictSchoolField.vue?vue&type=script&lang=js&"
export * from "./DistrictSchoolField.vue?vue&type=script&lang=js&"
import style0 from "./DistrictSchoolField.vue?vue&type=style&index=0&id=42224642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42224642",
  null
  
)

export default component.exports